import { ComponentProps } from 'react';
import { bordColorTheme } from '../../../../styles/styles.constants';

/**
 * Icono de libro abierto para BordOneToneIcon
 */
const BordOpenBookIcon = (props: ComponentProps<'svg'>) => {
  const { stroke } = props;
  return (
    <svg viewBox="0 0 11 10" fill="none">
      <path
        d="M5.5 2.5C5.5 1.96957 5.71071 1.46086 6.08579 1.08579C6.46086 0.710714 6.96957 0.5 7.5 0.5H10.5V8H7C6.60218 8 6.22064 8.15804 5.93934 8.43934C5.65804 8.72064 5.5 9.10218 5.5 9.5M5.5 2.5V9.5M5.5 2.5C5.5 1.96957 5.28929 1.46086 4.91421 1.08579C4.53914 0.710714 4.03043 0.5 3.5 0.5H0.5V8H4C4.39782 8 4.77936 8.15804 5.06066 8.43934C5.34196 8.72064 5.5 9.10218 5.5 9.5"
        stroke={stroke || bordColorTheme.navyBlue[400]}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BordOpenBookIcon;
